<img [ngSrc]="sponsor().logo" [alt]="sponsor().name ? sponsor().name + ' logo' : ''" width="60" height="30">
<h3>{{ cardInfo().title }}</h3>
<span>{{ sponsor().name }}</span>
<p [class.clip-text]="!isExpand()">{{ cardInfo().description }}</p>
<button type="button" class="toggle-description" (click)="toggleExpand($event)">{{ isExpand() ? 'Read less' : 'Read more' }}
</button>
<div class="badges">
  @for (badge of badges(); track badge) {
    <p>{{ badge }}</p>
  }
</div>
